/**

 * JavaScript functions for SIW_IPP_LGN.HTS - v1.0 Chris Salt
 * 11/03/2014
 */

import $ from 'jquery';

$(document).ready(function () {

    let handleSitsErrors;
    let toggleNewUser;

    /*********************************************************************/
    /* FUNCTION DECLARATIONS                                             */
    /*********************************************************************/

    //Handle errors generated by the server to highlight fields
    handleSitsErrors = function () {

        //Find specific known error codes and highlight fields as necessary
        const messageCode = $('.sv-message-box').text();

        //SITS_LOGIN_ERROR_002 - Invalid username error
        if (messageCode.search('SITS_LOGIN_ERROR_002') !== -1) {
            $('#usernameGroup').addClass('has-error');
            $('#usernameGroup').find('.form-control-feedback i').addClass('fa fa-warning');
        }

        //SITS_LOGIN_ERROR_003 - password error
        if (messageCode.search('SITS_LOGIN_ERROR_003') !== -1) {
            $('#passwordGroup').addClass('has-error');
            $('#passwordGroup').find('.form-control-feedback i').addClass('fa fa-warning');
        }

        //SITS_LOGIN_ERROR_004 - Incorrect username/password error
        if (messageCode.search('SITS_LOGIN_ERROR_004') !== -1) {
            $('#usernameGroup').addClass('has-error');
            $('#usernameGroup').find('.form-control-feedback i').addClass('fa fa-warning');
            $('#passwordGroup').addClass('has-error');
            $('#passwordGroup').find('.form-control-feedback i').addClass('fa fa-warning');
        }
    };

    //Hide new user section if necessary - look at whether sits creates submit button
    toggleNewUser = function () {
        if ($('#NEW_USER').length < 1) {
            $('#new_user_section').hide();
        }
    };

    /*********************************************************************/
    /* EVENTS                                                            */
    /*********************************************************************/
    $('#ippLgnForm').on('submit', function () {
        $('#loadingModal').modal({
            backdrop: 'static',
            keyboard: false
        });
    });

    /*********************************************************************/
    /* RUN                                                               */
    /*********************************************************************/
    handleSitsErrors();
    toggleNewUser();
    $('#MUA_CODE').focus();
});



// WEBPACK FOOTER //
// ./ku/js/siw_ipp_lgn.js